import { Injectable } from '@angular/core';
import { EventData } from '../models/event-data';
import { lastValueFrom, Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../../shared/models/api-response';

@Injectable({
  providedIn: 'root'
})
export class EventService {
  private baseUrl = environment.vibrationApiURL;


  constructor(private httpClient: HttpClient) { }

  updateVibrationEvent(
    siteId: number,
    vibrationEvent: EventData
  ): Observable<ApiResponse<EventData>> {
    return this.httpClient.patch<ApiResponse<EventData>>(
      `$${this.baseUrl}/sites/${siteId}/events`,
      vibrationEvent
    );
  }

  createOrUpdateVibrationEvent(
    siteId: number,
    vibrationEvent: EventData,
    isEdit: boolean,
  ): Observable<ApiResponse<EventData>> {
    let url = `${this.baseUrl}/sites/${siteId}/events`;
    if (isEdit) {
      url = `${url}/${vibrationEvent.id}`;
      return this.httpClient.put<ApiResponse<EventData>>(url, vibrationEvent);
    } else {
      return this.httpClient.post<ApiResponse<EventData>>(url, vibrationEvent);
    }
  }


  getVibrationEvents(siteId: number, controlPointId: number): Observable<ApiResponse<EventData[]>> {
    let params = new HttpParams();
    if (controlPointId !== undefined && controlPointId !== null && !isNaN(controlPointId)) {
      params = params.append('controlPointId', controlPointId);
    }
    return this.httpClient.get<ApiResponse<EventData[]>>(
      `${this.baseUrl}/sites/${siteId}/events`,
      { params }
    );
  }
    getControlPointsByEventId(siteId: number, eventId?: number): Observable<ApiResponse<number[]>> {
    let params = new HttpParams();
    if (eventId !== undefined && eventId !== null && !isNaN(eventId)) {
      params = params.append('eventId', eventId.toString());
    }
    return this.httpClient.get<ApiResponse<number[]>>(
      `${this.baseUrl}/sites/${siteId}/events/${eventId}/controlPoints`,
      { params }
    );
  }

  async getVibrationEventsAsync(siteId: number): Promise<ApiResponse<EventData[]>> {
    return await lastValueFrom(this.httpClient.get<ApiResponse<EventData[]>>(
      `${this.baseUrl}/sites/${siteId}/events`
    ));
  }

  getVibrationEvent(
    siteId: number,
    eventId: number,
  ): Observable<ApiResponse<EventData>> {
    return this.httpClient.get<ApiResponse<EventData>>(
      `${this.baseUrl}/sites/${siteId}/events/${eventId}`
    );
  }

  deleteVibrationEvent(
    siteId: number,
    eventId: number,)
    : Observable<ApiResponse<boolean>> {
    return this.httpClient.delete<ApiResponse<boolean>>(
      `${this.baseUrl}/sites/${siteId}/events/${eventId}`
    );
  }
}

